define(['marionette', 'backbone', './template.html'], function (
  MN,
  Backbone,
  popoverTemplate
) {
  return MN.ItemView.extend({
    template: popoverTemplate,
    events: {
      mouseenter: 'show',
      mouseleave: 'hide'
    },
    options: {
      popoverMessage: '',
      cssClass: ''
    },
    templateHelpers: function () {
      return {
        popoverMessage: this.options.popoverMessage,
        cssClass: this.options.cssClass
      }
    },
    hide: function () {
      var self = this
      clearTimeout(self.hideTimeout)
      self.hideTimeout = setTimeout(function () {
        self.$el.fadeOut()
      }, 300)
    },
    show: function () {
      this.clearTimeout()
    },
    clearTimeout: function () {
      clearTimeout(this.hideTimeout)
    },
    setPosition: function (topPosition, leftPosition) {
      this.$el
        .css({
          position: 'absolute',
          top: topPosition,
          left: leftPosition
        })
        .stop()
        .fadeIn()
    },
    setLinkUrl: function (linkUrl) {
      if (!linkUrl) {
        return
      }
      this.model.set('linkUrl', linkUrl)
    },
    initialize: function () {
      this.model = new Backbone.Model({
        linkUrl: this.options.linkUrl
      })
      this.model.on('change:linkUrl', this.render)
    }
  })
})
